import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AdtfDeviceOverviewContextProvider from "./context/AdtfDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ADTF} from "../../util/RouteConstants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AdtfDevicePage extends Component {
    render() {
        return (
            <Column>
                <AdtfDeviceOverviewContextProvider>
                    <TabLayout routes={ADTF} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ADTF}/>
                </AdtfDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AdtfDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/AdtfDevicePage.js